import React from "react";
import { UiBox } from "~/components/elements";
import useMetaTags, { MetaTagsConfig } from "react-metatags-hook";
import { BoxProps } from "@chakra-ui/react";
import { PAGES } from "~/constants";
import { setDidRedirect } from "~/redux/dashboards/slice";
import { useHistory, useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "~/hooks";
import { useSearchParams } from "~/utils/helpers/react-router-helper";

interface Props extends BoxProps {
  children: React.ReactNode;
  metaTagsConfig: MetaTagsConfig;
  isInGeneratingStep?: boolean;
}

export function PageLayout({ metaTagsConfig, isInGeneratingStep = false, children, ...rest }: Props) {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const didRedirect = useAppSelector(state => state.dashboard.didRedirect);
  const pendingJobId = useAppSelector(state => state.dashboard.jobId);
  const user = useAppSelector(state => state.auth.currentUser || {});

  // Check if this is an upsell flow
  const isUpsellFlow = searchParams.get("type") === "upsell";

  useMetaTags(metaTagsConfig, []);
  // @ts-ignore
  const isFromBackButton = String(window.performance.getEntriesByType("navigation")[0]?.type) === "back_forward";

  // Skip redirect logic for upsell flow
  if (isInGeneratingStep && !didRedirect && !isFromBackButton && !isUpsellFlow) {
    let to = "";
    if (pendingJobId) {
      // const currentSurveyIds = storage.load(DASHBOARD_STORAGE_KEYS.SURVEY_IDS);
      // if (isEmpty(currentSurveyIds)) {
      //   to = PAGES.SURVEY;
      // } else {
      to = PAGES.SELECT_STYLES;
      // }
    } else if (user.is_all_access_plan) {
      to = PAGES.VIEW_RESULTS;
    } else {
      to = `${PAGES.DASHBOARD}?is_new_hs=1`;
    }
    dispatch(setDidRedirect(true));
    if (to && location.pathname !== to) {
      history.replace(to);
    }
    return null;
  }

  return <UiBox {...rest}>{children}</UiBox>;
}
